// extracted by mini-css-extract-plugin
export default {"confirmationPopup":"ConfirmationPopup_confirmationPopup__XkLmc","button":"ConfirmationPopup_button__vAudK","message":"ConfirmationPopup_message__EL1XL"};